import { render, staticRenderFns } from "./CoinGeckoMention.vue?vue&type=template&id=b38f76ea&scoped=true&"
import script from "./CoinGeckoMention.vue?vue&type=script&lang=js&"
export * from "./CoinGeckoMention.vue?vue&type=script&lang=js&"
import style0 from "./CoinGeckoMention.vue?vue&type=style&index=0&id=b38f76ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b38f76ea",
  null
  
)

export default component.exports